var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-call-01",
    clipPath: "url(#clip0_402_604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.59317 3.99992C10.2443 4.12696 10.8428 4.44542 11.3119 4.91454C11.781 5.38366 12.0995 5.9821 12.2265 6.63325M9.59317 1.33325C10.946 1.48354 12.2076 2.08937 13.1707 3.05126C14.1338 4.01315 14.7412 5.27393 14.8932 6.62659M7.04449 9.24196C6.24343 8.44091 5.61091 7.53515 5.14691 6.56874C5.107 6.48561 5.08704 6.44405 5.07171 6.39145C5.01723 6.20455 5.05636 5.97505 5.1697 5.81676C5.2016 5.77222 5.2397 5.73411 5.31591 5.65791C5.54898 5.42483 5.66552 5.3083 5.74171 5.19111C6.02904 4.74919 6.02904 4.17947 5.74171 3.73754C5.66552 3.62035 5.54898 3.50382 5.31591 3.27075L5.186 3.14084C4.8317 2.78654 4.65455 2.60939 4.4643 2.51316C4.08593 2.32178 3.63908 2.32178 3.26071 2.51316C3.07046 2.60939 2.89331 2.78654 2.53901 3.14084L2.43392 3.24593C2.08084 3.59901 1.9043 3.77555 1.76947 4.01557C1.61985 4.28191 1.51228 4.69557 1.51319 5.00105C1.51401 5.27635 1.56741 5.4645 1.67422 5.84079C2.2482 7.86306 3.33118 9.7713 4.92317 11.3633C6.51515 12.9553 8.42339 14.0383 10.4457 14.6122C10.822 14.719 11.0101 14.7724 11.2854 14.7733C11.5909 14.7742 12.0045 14.6666 12.2709 14.517C12.5109 14.3822 12.6874 14.2056 13.0405 13.8525L13.1456 13.7474C13.4999 13.3931 13.6771 13.216 13.7733 13.0257C13.9647 12.6474 13.9647 12.2005 13.7733 11.8221C13.6771 11.6319 13.4999 11.4547 13.1456 11.1005L13.0157 10.9705C12.7826 10.7375 12.6661 10.6209 12.5489 10.5447C12.107 10.2574 11.5373 10.2574 11.0953 10.5447C10.9782 10.6209 10.8616 10.7375 10.6285 10.9705C10.5523 11.0467 10.5142 11.0849 10.4697 11.1167C10.3114 11.2301 10.0819 11.2692 9.895 11.2147C9.8424 11.1994 9.80084 11.1795 9.71771 11.1395C8.7513 10.6755 7.84554 10.043 7.04449 9.24196Z",
    stroke: "#5732AB",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.226562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.655af2c651082704c948d485c54cbedb.svg";
export { ForwardRef as ReactComponent };